import types from './types';

function referencesReducer(state, action) {
  switch(action.type) {
    case types.SET_CREDIT:
      return {...state, credit: action.credit }
    case types.SET_SOLICITATION:
      return {...state, solicitation: action.solicitation }
    case types.SET_SELECTED_FIRST_STATE:
      return {...state, personal: {...state.personal, first: { ...state.personal.first, state: action.state }}}
    case types.SET_SELECTED_FIRST_CITY:
      return {...state, personal: {...state.personal, first: { ...state.personal.first, city: action.city }}}
    case types.SET_SELECTED_FIRST_RELATIONSHIP:
      return {...state, personal: {...state.personal, first: { ...state.personal.first, relationship: action.relationship }}}
    case types.SET_SELECTED_SECOND_STATE:
      return {...state, personal: {...state.personal, second: { ...state.personal.second, state: action.state }}}
    case types.SET_SELECTED_SECOND_CITY:
      return {...state, personal: {...state.personal, second: { ...state.personal.second, city: action.city }}}
    case types.SET_SELECTED_SECOND_RELATIONSHIP:
      return {...state, personal: {...state.personal, second: { ...state.personal.second, relationship: action.relationship }}}
    case types.SET_PERSONAL:
      return {...state, personal: action.personal}
    case types.SET_SELECTED_FAMILY_FIRST_STATE:
      return {...state, family: {...state.family, first: { ...state.family.first, state: action.state }}}
    case types.SET_SELECTED_FAMILY_FIRST_CITY:
      return {...state, family: {...state.family, first: { ...state.family.first, city: action.city }}}
    case types.SET_SELECTED_FAMILY_FIRST_RELATIONSHIP:
      return {...state, family: {...state.family, first: { ...state.family.first, relationship: action.relationship }}}
    case types.SET_SELECTED_FAMILY_SECOND_STATE:
      return {...state, family: {...state.family, second: { ...state.family.second, state: action.state }}}
    case types.SET_SELECTED_FAMILY_SECOND_CITY:
      return {...state, family: {...state.family, second: { ...state.family.second, city: action.city }}}
    case types.SET_SELECTED_FAMILY_SECOND_RELATIONSHIP:
      return {...state, family: {...state.family, second: { ...state.family.second, relationship: action.relationship }}}
    case types.SET_FAMILY:
      return {...state, family: action.family}
    default:
      return state;
  }
}

export default referencesReducer;
